import styled, { css } from 'styled-components'
import { theme } from '@mtsdengi/ui-kit'
import { Image as SharedImage, getResponsiveStyles } from '@mtsdengi/common'

const Image = styled(SharedImage)<{ imageFillMode: string }>`
  width: 100%;
  height: 100%;
  text-align: right;

  img {
    height: 100%;
    width: 100%;
    object-position: bottom right;
    ${({ imageFillMode }) =>
      imageFillMode
        ? getResponsiveStyles('object-fit', imageFillMode)
        : css`
            object-fit: contain;
          `};
    }
  }
`

const Grid = styled.div`
  display: grid;
  grid-gap: ${theme.spacings.xs}px ${theme.spacings.md}px;

  @media (min-width: ${theme.breakpoints.md}px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (min-width: ${theme.breakpoints.lg}px) {
    grid-template-columns: 546px auto;
  }

  @media (min-width: ${theme.breakpoints.uber}px) {
    grid-template-columns: 628px auto;
  }
`

export const Styled = {
  Image,
  Grid,
}
